const type = process.env.NODE_ENV
// 8984（2）  8988（2.1） 8989（国产）
let baseUrl =  ""
let imageBaseUrl =  ""
if(type === 'development') {
  baseUrl = 'http://192.168.10.130:9001/'//测试环境
  imageBaseUrl = 'http://192.168.10.130:9001/'
}else {
  baseUrl =  window.location.origin//测试环境
  imageBaseUrl =  window.location.origin
}

export { baseUrl, imageBaseUrl}





// WEBPACK FOOTER //
// ./src/config/env.js